module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_8-2.936529a3.png";